import { render, staticRenderFns } from "./ModalPersonalizationEditor.vue?vue&type=template&id=07f4c20d&scoped=true"
import script from "./ModalPersonalizationEditor.vue?vue&type=script&lang=js"
export * from "./ModalPersonalizationEditor.vue?vue&type=script&lang=js"
import style0 from "./ModalPersonalizationEditor.vue?vue&type=style&index=0&id=07f4c20d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4c20d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f4c20d')) {
      api.createRecord('07f4c20d', component.options)
    } else {
      api.reload('07f4c20d', component.options)
    }
    module.hot.accept("./ModalPersonalizationEditor.vue?vue&type=template&id=07f4c20d&scoped=true", function () {
      api.rerender('07f4c20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalPersonalizationEditor.vue"
export default component.exports